import { IMessageProps } from '.';
import { Severity, getHighestSeverity } from '../../../Data/ViewModels/Core/Severity';
import { hasNonEmptyValue } from 'Lib/Any';

/**
 * TODO: Messages should be defined as a type separate from the properties of the message component
 * When this is done, this code should be moved outside of the components layer.
 *
 * @param messages
 * @returns Highest severity of these messages
 */
export const getHighestMessageSeverity = (messages: IMessageProps[] | undefined): Severity =>
  hasNonEmptyValue(messages) ? getHighestSeverity((messages as IMessageProps[]).map((m) => m?.severity)) : undefined;
